module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "barcharts"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-sm-offset-2"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('barcharts', {
    ref: "sparks",
    attrs: {
      "colorOne": _vm.colorOne,
      "labelOne": _vm.labelOne,
      "colorTwo": _vm.colorTwo,
      "labelTwo": _vm.labelTwo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(" Settings ")]), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v("\n        Label 1: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.labelOne),
      expression: "labelOne"
    }],
    attrs: {
      "placeholder": _vm.labelOne
    },
    domProps: {
      "value": (_vm.labelOne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.labelOne = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v("\n        Color 1: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colorOne),
      expression: "colorOne"
    }],
    attrs: {
      "placeholder": _vm.colorOne
    },
    domProps: {
      "value": (_vm.colorOne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colorOne = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v("\n        Label 2: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.labelTwo),
      expression: "labelTwo"
    }],
    attrs: {
      "placeholder": _vm.labelTwo
    },
    domProps: {
      "value": (_vm.labelTwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.labelTwo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v("\n        Color 2: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colorTwo),
      expression: "colorTwo"
    }],
    attrs: {
      "placeholder": _vm.colorTwo
    },
    domProps: {
      "value": (_vm.colorTwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colorTwo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "button expanded",
    staticStyle: {
      "width": "80%",
      "display": "none"
    },
    on: {
      "click": function($event) {
        _vm.generate()
      }
    }
  }, [_vm._v("\n          New random data\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dbe1842"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BarchartsContainer.vue
// module id = 38
// module chunks = 0